import React, {useState} from 'react'

export const AsyncImage = ({alt, ...imageProps}) => {
    const [isLoaded, setIsLoaded] = useState(false)

    return (
        <>
            <img
                {...imageProps}
                style={{ display: isLoaded ? '' : 'none'}}
                onLoad={() => setIsLoaded(true)}
                onError={() => setIsLoaded(false)}
            />
            {
                !isLoaded && alt
            }
        </>
    )
}